import { useState, type ReactNode } from 'react';
import { Icone, type NomIcone } from './icones.tsx';
import { appliquerTheme, themeMemorise, themeSuivant, LIBELLE_THEME, type Theme } from '../theme/theme.ts';

const ICONE_PAR_THEME: Record<Theme, NomIcone> = {
  systeme: 'ecran',
  clair: 'soleil',
  sombre: 'lune',
};

/**
 * Bascule d'apparence — clair / sombre / système, dans le pied du rail.
 *
 * Un seul bouton qui CYCLE plutôt que trois boutons ou un menu déroulant :
 * c'est un réglage qu'on touche rarement, il ne mérite pas plus de place
 * dans le rail qu'« avatar + déconnexion ».
 */
export function BoutonTheme(): ReactNode {
  const [theme, setTheme] = useState<Theme>(() => themeMemorise());

  return (
    <button
      type="button"
      className="rail__theme"
      title={`Apparence : ${LIBELLE_THEME[theme]}. Changer.`}
      aria-label={`Apparence : ${LIBELLE_THEME[theme]}. Changer.`}
      onClick={() => {
        const suivant = themeSuivant(theme);
        appliquerTheme(suivant);
        setTheme(suivant);
      }}
    >
      <Icone nom={ICONE_PAR_THEME[theme]} taille={16} />
    </button>
  );
}
